<template>
  <div style="background-color: rgb(242, 242, 242); height: 100vh;">
    <!-- <div v-if="$route.params.region"> -->
    <header-navigation></header-navigation>
    <!-- </div> -->
    <pageloader v-if="pageload" />
    <div v-if="bannerContent">
      <banner :acf="bannerContent" :data="bannerContent"></banner>
    </div>
    <div v-if="newsfeed != null">
      <profhpwrapper
        :newsFeedsacf="newsfeed"
        :announcementsacf="announcements"
        :extLinkCardsacf="extcardone"
        :extLinkCardsWdacf="extcardtwo"
      ></profhpwrapper>
    </div>
    <template v-for="(block, index) in content">
      <component
        :is="block.acf_fc_layout"
        v-bind:acf="block['component-d741a204']"
        v-bind:data="block['component-d741a204']"
        :key="index"
      ></component>
    </template>
    <div v-if="animation">
      <section
        class="for-professionals"
        resmed-component-name="for-professionals"
      >
        <for-professionals v-bind="animation"> </for-professionals>
      </section>
    </div>
    <div v-if="glossary">
      <component-f7d0bf1d v-bind:acf="glossary"></component-f7d0bf1d>
    </div>
    <a href="#" class="to-top">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 24 24"
        border-radius="20%"
        fill="none"
        style="background-color: #0D0A15"
        stroke-width="2"
        stroke-linecap="round"
        stroke="white"
      >
        <path d="M18 15l-6-6-6 6" />
      </svg>
    </a>
    <div v-if="$route.params.region">
      <footer>
        <nav class="company-pages px-3 px-md-0">
          <div class="container">
            <div class="">
              <footer-navigation
                v-bind:category="'quick-links'"
              ></footer-navigation>
            </div>
            <hr class="d-none d-md-block" />

            <div class="row">
              <div class="col-lg-8 my-5 mt-md-0 my-lg-0">
                <footer-navigation
                  v-bind:category="'useful-links'"
                ></footer-navigation>
              </div>

              <div class="col-lg-4">
                <social-media></social-media>
                <div class="copyright-disclaimers d-none d-md-block">
                  <p>
                    <span>© ResMed</span>
                    {{
                      $getTranslation(
                        "All rights reserved.",
                        $route.params.region
                      )
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </footer>
      <modal-video></modal-video>
    </div>
  </div>
</template>

<script>
// import jsonData from "./assets/data.json";
// import group from "./components/navigation/group.vue";
import headerNavigation from "./components/navigation/header.vue";
import footerNavigation from "./components/navigation/footer.vue";
import socialMedia from "./components/navigation/social-media.vue";
import profhpwrapper from "./components/shared/profhpwrapper.vue";
// import announcements from './components/shared/announcements.vue';
import banner from "./components/consumers/FSN_Banner_Title.vue";
import _ from "lodash";
import { mapMutations, mapState } from "vuex";
import ComponentD741a204 from "./components/shared/component-d741a204.vue";
import wpApi from "./services/wpApi";

export default {
  components: {
    headerNavigation,
    footerNavigation,
    socialMedia,
    profhpwrapper,
    banner,
  },
  data() {
    return {
      content: {},
      animation: null,
      glossary: null,
      newsfeed: null,
      announcements: null,
      extcardone: null,
      extcardtwo: null,
      carddata: null,
      bannerContent: null,
      pageload: true,
      metaData: {},
      userSession: null,
    };
  },
  name: "AstralFSNPage",
  metaInfo() {
    return {
      title: this.metaData.title || "Resmed Product Support",
      meta: [
        { name: "description", content: this.metaData.description },
        { name: " title", content: this.metaData.title },
      ],
    };
  },
  created() {},
  async mounted() {
    if (this.$route.hash) {
      this.waitForElm(this.$route.hash).then((elm) => {
        setTimeout(() => {
          $([document.documentElement, document.body]).animate(
            {
              scrollTop: $(this.$route.hash).offset().top,
            },
            400
          );
        }, 400);
      });
    }
    if (
      this.$route.params.category !=
      this.$getCategoryTranslation(
        this.$route.params.category,
        this.$route.params.region
      )
    ) {
      this.$router.push({
        params: {
          name: "AstralFSNPage",
          category: this.$getCategoryTranslation(
            this.$route.params.category,
            this.$route.params.region
          ),
          region: this.$route.params.region,
        },
      });
    }

    const useremail = $cookies.get("rocEmail");
    const usersid = $cookies.get("rocSid");
    const userid = $cookies.get("userId");
    let oktaEndpoint = $cookies.get("rocServ");
    if (usersid && oktaEndpoint) {
      try {
        await axios
          .get(`${oktaEndpoint}v1/account/session`, {
            headers: {
              OKTA_SID: `${usersid}`,
              "Content-Type": "application/json",
              region: `${this.$route.params.region}`,
            },
          })
          .then((item) => {
            this.setUserId(userid);
            this.setCountry(item.data.user.country);
          });
      } catch (error) {
        this.removeAllCookies();
        this.userSession = null;
        console.log(error);
      }
    }

    try {
      const data = await wpApi.getPageBySlug("page-technique-astral-fsn-2023-phase-2");
      this.pageload = false;

      this.metaData = {
        title: data.metatitle,
        description: data.metadesc,
      };

      const toTop = document.querySelector(".to-top");
      window.addEventListener("scroll", () => {
        if (window.pageYOffset > 100) {
          toTop.classList.add("active");
        } else {
          toTop.classList.remove("active");
        }
      });

      const ignoreComponents = [
        "banner",
        "newsfeed-component",
        "announcements",
        "extlinkcards",
        "extlinkcardswd",
      ];

      this.content = _.filter(
        data.data.fields,
        (item) => !_.includes(ignoreComponents, item.acf_fc_layout)
      );

      if (
        this.$route.params.category &&
        data.data.category &&
        this.$getCategory(
          this.$route.params.category,
          this.$route.params.region
        ) != data.data.category
      ) {
        window.location.href = `/${this.$route.params.region}/${
          data.data.category
        }/${this.$route.params.slug}`;
      }

      // this.newsfeed = this.getComponentData(data, "newsfeed-component");
      // this.announcements = this.getComponentData(data, "announcements");
      // this.extcardone = this.getComponentData(data, "extlinkcards");
      // this.extcardtwo = this.getComponentData(data, "extlinkcardswd");
      this.bannerContent = await this.getComponentData(data, "banner");

      this.pageNotFound(data.data.fields);
    } catch (e) {
      this.pageNotFound();
    }
  },
  computed: {
    ...mapState(["userId, country", "showLinks"]),
    myFields: () => JSON.parse(JSON.stringify(this.content)),
  },
  methods: {
    ...mapMutations(["setUserId", "setCountry"]),
    waitForElm(selector) {
      return new Promise((resolve) => {
        if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver((mutations) => {
          if (document.querySelector(selector)) {
            observer.disconnect();
            resolve(document.querySelector(selector));
          }
        });

        // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });
      });
    },
    pageNotFound(data) {
      if (data == null) {
        this.$router.push({
          name: "404",
          params: {
            region: this.$route.params.region,
            slug: "-page-sleep-apnea",
          },
        });
      }
    },
    getComponentData(data, componentName) {
      if (!data.data.fields) {
        return null;
      }
      const component = _.find(data.data.fields, [
        "acf_fc_layout",
        componentName,
      ]);
      if (component) {
        return component[componentName];
      } else {
        return null;
      }
    },
    removeAllCookies() {
      $cookies.remove(
        "rocServ",
        null,
        window.location.hostname === "localhost" ? "localhost" : "resmed.com"
      );
      $cookies.remove(
        "rocEmail",
        null,
        window.location.hostname === "localhost" ? "localhost" : "resmed.com"
      );
      $cookies.remove(
        "rocSid",
        null,
        window.location.hostname === "localhost" ? "localhost" : "resmed.com"
      );
      $cookies.remove(
        "RegionCode",
        null,
        window.location.hostname === "localhost" ? "localhost" : "resmed.com"
      );
      $cookies.remove(
        "b2bFirstName",
        null,
        window.location.hostname === "localhost" ? "localhost" : "resmed.com"
      );
      $cookies.remove(
        "role",
        null,
        window.location.hostname === "localhost" ? "localhost" : "resmed.com"
      );
      $cookies.remove(
        "redirectLoggedPath",
        null,
        window.location.hostname === "localhost" ? "localhost" : "resmed.com"
      );
    },
  },
};
</script>

<style>
.for-professionals {
  padding: 7rem 0 1rem 0;
}
.to-top {
  color: white;
  position: fixed;
  bottom: 16px;
  right: 40px;
  width: 100px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  text-decoration: none;
  opacity: 0;
  pointer-events: none;
  /* transition: all .4s; */
}
.to-top.active {
  bottom: 32px;
  pointer-events: auto;
  opacity: 1;
  z-index: 101;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
@media (max-width: 768px) {
  .to-top {
    right: 0;
  }
}
</style>
